var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" "+_vm._s(_vm.toggled ? _vm.text : _vm.truncatedText)+" "),(!_vm.shortText)?_c('ButtonLink',{attrs:{"text":_vm.toggled ? _vm.lessText : _vm.moreText},on:{"click":_vm.toggle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }